import MasterDetails from "./MasterDetails.vue";
import { pluginify } from "./../../util";

pluginify(MasterDetails);

export default MasterDetails;

export { MasterDetails };
